<!-- 费用项配置弹窗 -->
<template>
  <!-- 添加费用项弹窗 -->
  <el-dialog :title="$t('common.add')" :visible.sync="visible" width="80%" @close="resetForm">
    <el-form :model="form" :rules="rules" label-width="150px" ref="form">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('feeConfigManage.feeType')" prop="feeTypeCd" required>
            <el-select v-model="form.feeTypeCd" @change="changeAddFeeTypeCd"
              :placeholder="$t('feeConfigManage.feeType')" class="full-width-select">
              <el-option v-for="item in feeTypeCds" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('feeConfigManage.feeItem')" prop="feeName" required>
            <el-input v-model="form.feeName" :placeholder="$t('feeConfigManage.enterFeeItem')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('feeConfigManage.feeFlag')" prop="feeFlag" required>
            <el-select v-model="form.feeFlag" :placeholder="$t('feeConfigManage.selectFeeFlag')"
              class="full-width-select">
              <el-option v-for="item in feeFlags" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('feeConfigManage.paymentType')" prop="paymentCd" required>
            <el-select v-model="form.paymentCd" :placeholder="$t('feeConfigManage.selectPaymentType')"
              class="full-width-select">
              <el-option v-for="item in paymentCds" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if="form.feeFlag != '2006012'">
          <el-form-item :label="$t('feeConfigManage.paymentCycle')" prop="paymentCycle" required>
            <el-input v-model="form.paymentCycle" :placeholder="$t('feeConfigManage.enterPaymentCycle')" />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.paymentCd == '1200'">
          <el-form-item :label="$t('feeConfigManage.prepaymentPeriod')" prop="prepaymentPeriod" required>
            <el-input v-model="form.prepaymentPeriod" :placeholder="$t('feeConfigManage.enterPrepaymentPeriod')" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('feeConfigManage.unit')" prop="units" required>
            <el-input v-model="form.units" :placeholder="$t('feeConfigManage.enterUnit')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('feeConfigManage.accountDeduction')" prop="deductFrom">
            <el-select v-model="form.deductFrom" class="full-width-select">
              <el-option :label="$t('common.yes')" value="Y" />
              <el-option :label="$t('common.no')" value="N" />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('feeConfigManage.mobilePayment')" prop="payOnline">
            <el-select v-model="form.payOnline" class="full-width-select">
              <el-option :label="$t('common.yes')" value="Y" />
              <el-option :label="$t('common.no')" value="N" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('feeConfigManage.roundingMethod')" prop="scale">
            <el-select v-model="form.scale" class="full-width-select">
              <el-option :label="$t('feeConfigManage.roundHalfUp')" value="1" />
              <el-option :label="$t('feeConfigManage.roundUp')" value="3" />
              <el-option :label="$t('feeConfigManage.roundDown')" value="4" />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('feeConfigManage.decimalPlaces')" prop="decimalPlace">
            <el-select v-model="form.decimalPlace" class="full-width-select">
              <el-option :label="$t('feeConfigManage.integer')" value="0" />
              <el-option :label="$t('feeConfigManage.oneDecimal')" value="1" />
              <el-option :label="$t('feeConfigManage.twoDecimal')" value="2" />
              <el-option :label="$t('feeConfigManage.threeDecimal')" value="3" />
              <el-option :label="$t('feeConfigManage.fourDecimal')" value="4" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('common.status')" prop="state">
            <el-select v-model="form.state" class="full-width-select">
              <el-option :label="$t('common.enabled')" value="Y" />
              <el-option :label="$t('common.disabled')" value="N" />
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 费用类型选择 -->
        <el-col :span="24">
          <el-form-item :label="$t('feeConfigManage.formula')" prop="computingFormula" >
            <el-select v-model="form.computingFormula" :placeholder="$t('feeConfigManage.selectFormula')"
              class="full-width-select" @change="handleFormulaChange">
              <el-option v-for="item in computingFormulas" :key="item.statusCd" :label="item.name"
                :value="item.statusCd" />
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 启用梯度费用开关（仅自定义公式7007显示） -->
        <el-col :span="24" v-if="form.computingFormula === '7007'">
          <el-form-item :label="$t('feeConfigManage.enableTieredFee')" :label-width="'150px'">
            <el-switch v-model="showTieredFeeSwitch" />
            <span style="margin-left: 10px; color: #909399; font-size: 12px;">{{ $t('feeConfigManage.enableTieredFeeTip') }}</span>
          </el-form-item>
        </el-col>

        <!-- 单价输入框 -->
        <template v-if="shouldShowUnitPrice">
          <el-col :span="24">
            <el-form-item :label="$t('feeConfigManage.unitPrice')" prop="squarePrice" >
              <el-input v-model="form.squarePrice" :placeholder="$t('feeConfigManage.enterUnitPrice')" />
            </el-form-item>
          </el-col>
        </template>

        <!-- 附加费/固定费用输入框 -->
        <template v-if="shouldShowAdditionalAmount">
          <el-col :span="24">
            <el-form-item :label="additionalAmountLabel" prop="additionalAmount" >
              <el-input v-model="form.additionalAmount" :placeholder="$t('feeConfigManage.enterAdditionalFee')" />
            </el-form-item>
          </el-col>
        </template>

        <!-- 自定义公式输入（7007且未启用梯度费用时显示） -->
        <template v-if="form.computingFormula == '7007' && !showTieredFeeSwitch">
          <el-col :span="24">
            <el-form-item :label="$t('feeConfigManage.formula')" prop="computingFormulaText" >
              <el-input type="textarea" v-model="form.computingFormulaText"
                :placeholder="$t('feeConfigManage.enterFormula')" :rows="4" />
            </el-form-item>
          </el-col>
          <el-col :span="24" class="text-left">
            <el-form-item :label="$t('common.explanation')">
              <div>C {{ $t('feeConfigManage.explanationC') }}</div>
              <div>F {{ $t('feeConfigManage.explanationF') }}</div>
              <div>U {{ $t('feeConfigManage.explanationU') }}</div>
              <div>R {{ $t('feeConfigManage.explanationR') }}</div>
              <div>X {{ $t('feeConfigManage.explanationX') }}</div>
              <div>L {{ $t('feeConfigManage.explanationL') }}</div>
              <div>{{ $t('feeConfigManage.example1') }}</div>
              <div>{{ $t('feeConfigManage.example2') }}</div>
            </el-form-item>
          </el-col>
        </template>

        <!-- 梯度费用设置区域（启用梯度费用时显示） -->
        <template v-if="showTieredFee || showTieredFeeSwitch">
          <el-col :span="24">
            <el-divider>{{ $t('feeConfigManage.tieredFeeSetting') }}</el-divider>
          </el-col>
          <!-- 用量变量输入 -->
          <el-col :span="24">
            <el-form-item :label="$t('feeConfigManage.usageVariable')" :label-width="'150px'">
              <el-input v-model="tieredFeeSettings.usageVariable" :placeholder="$t('feeConfigManage.usageVariableTip')" style="width: 200px;" />
              <span style="margin-left: 10px; color: #909399; font-size: 12px;">{{ $t('feeConfigManage.usageVariableTip') }}</span>
            </el-form-item>
          </el-col>
          <!-- 叠加计费开关 -->
          <el-col :span="24">
            <el-form-item :label="$t('feeConfigManage.cumulative')" :label-width="'150px'">
              <el-switch v-model="tieredFeeSettings.cumulative" />
              <span style="margin-left: 10px; color: #909399; font-size: 12px;">{{ $t('feeConfigManage.cumulativeTip') }}</span>
            </el-form-item>
          </el-col>
          <!-- 梯度设置表格 -->
          <el-col :span="24">
            <el-table :data="tieredFeeSettings.tiers" border style="width: 100%; margin-bottom: 10px;">
              <el-table-column :label="$t('feeConfigManage.tierRange')" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.start" disabled style="width: 45%;" />
                  <span style="margin: 0 10px;">-</span>
                  <el-input v-model="scope.row.end" :placeholder="$t('feeConfigManage.tierEndPlaceholder')" style="width: 45%;" @input="updateNextTierStart(scope.$index)" />
                </template>
              </el-table-column>
              <el-table-column :label="$t('feeConfigManage.tierUnitPrice')" align="center" width="200">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.unitPrice" :placeholder="$t('feeConfigManage.unitPricePlaceholder')" />
                </template>
              </el-table-column>
              <el-table-column :label="$t('feeConfigManage.operation')" align="center" width="100">
                <template slot-scope="scope">
                  <el-button type="danger" size="mini" @click="removeTierRow(scope.$index)">
                    {{ $t('feeConfigManage.tierDelete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <!-- 添加梯度按钮 -->
          <el-col :span="24">
            <el-button type="primary" size="small" @click="addTierRow" style="margin-bottom: 10px;">
              {{ $t('feeConfigManage.addTier') }}
            </el-button>
            <span style="margin-left: 10px; color: #909399; font-size: 12px;">
              {{ $t('feeConfigManage.tierTip') }}
            </span>
          </el-col>
          <!-- 生成的公式显示与生成按钮 -->
          <el-col :span="24">
            <el-form-item :label="$t('feeConfigManage.generatedFormula')" :label-width="'150px'">
              <el-input v-model="form.computingFormulaText" type="textarea" :rows="3" style="width: 70%; margin-right: 10px;" />
              <el-button type="success" @click="generateFormula">
                {{ $t('feeConfigManage.generateFormula') }}
              </el-button>
            </el-form-item>
          </el-col>
          <!-- 费用示例表格 -->
          <el-col :span="24" v-if="tieredFeeExamples.length > 0">
            <el-form-item :label="$t('feeConfigManage.feeExample')" :label-width="'150px'">
              <el-table :data="tieredFeeExamples" size="mini" border style="width: auto;">
                <el-table-column :label="$t('feeConfigManage.usage')" align="center" width="120">
                  <template slot-scope="scope">
                    {{ scope.row.value }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('feeConfigManage.result')" align="center" width="150">
                  <template slot-scope="scope">
                    {{ getTotalFee(scope.row.value) }}{{ $t('feeConfigManage.yuan') }}
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>

    <div slot="footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveFeeConfigInfo">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
/**
 * 费用配置管理组件
 * 用于添加/编辑费用项配置，包括梯度费用设置
 */
import { saveFeeConfig } from '@/api/fee/feeConfigManageApi'
import { getDict } from '@/api/community/communityApi'

export default {
  name: 'AddFeeConfig',
  // 组件数据
  data() {
    return {
      visible: false,
      // 梯度费用相关数据
      showTieredFee: false,           // 是否显示梯度费用（旧版兼容）
      showTieredFeeSwitch: false,     // 梯度费用开关（7007公式时显示）
      tieredFeeSettings: {            // 梯度费用设置
        usageVariable: 'T',          // 用量变量名
        cumulative: false,           // 是否叠加计费
        tiers: [                      // 梯度列表
          { start: '0', end: '', unitPrice: '' }
        ]
      },
      // 表单数据
      form: {
        feeTypeCd: '',
        feeName: '',
        feeFlag: '',
        paymentCd: '1200',
        paymentCycle: '',
        prepaymentPeriod: '1',
        computingFormula: '',
        squarePrice: '',
        additionalAmount: '0.00',
        units: '元',
        deductFrom: 'Y',
        payOnline: 'Y',
        scale: '1',
        decimalPlace: '2',
        state: 'Y',
        computingFormulaText: '',
        startTime: '2025-01-01',
        endTime: '2050-01-01',
        billType: '002',
        communityId: this.getCommunityId()
      },
      feeTypeCds: [],
      computingFormulas: [],
      feeFlags: [],
      paymentCds: [],
      rules: {
        feeTypeCd: [{ required: true, message: this.$t('feeConfigManage.feeType'), trigger: 'change' }],
        feeName: [{ required: true, message: this.$t('feeConfigManage.enterFeeItem'), trigger: 'blur' }],
        feeFlag: [{ required: true, message: this.$t('feeConfigManage.selectFeeFlag'), trigger: 'change' }],
        paymentCd: [{ required: true, message: this.$t('feeConfigManage.selectPaymentType'), trigger: 'change' }],
        paymentCycle: [{ required: true, message: this.$t('feeConfigManage.enterPaymentCycle'), trigger: 'blur' }],
        prepaymentPeriod: [{ required: true, message: this.$t('feeConfigManage.enterPrepaymentPeriod'), trigger: 'blur' }],
        units: [{ required: true, message: this.$t('feeConfigManage.enterUnit'), trigger: 'blur' }],
        computingFormula: [{ required: true, message: this.$t('feeConfigManage.selectFormula'), trigger: 'change' }],
        computingFormulaText: [{ required: true, message: this.$t('feeConfigManage.enterFormula'), trigger: 'blur' }]
      }
    }
  },
  // 计算属性
  computed: {
    // 是否显示单价输入框
    shouldShowUnitPrice() {
      return !['2002', '7007', '8008', '9009', '1101', '1102', '4004'].includes(this.form.computingFormula)
    },
    // 是否显示附加费/固定费用输入框
    shouldShowAdditionalAmount() {
      return !['7007', '8008', '9009', '1101', '1102', '4004'].includes(this.form.computingFormula)
    },
    // 附加费/固定费用标签文本
    additionalAmountLabel() {
      return this.form.computingFormula == '1001'
        ? this.$t('feeConfigManage.additionalFee')
        : this.$t('feeConfigManage.fixedFee')
    },
    // 根据梯度设置自动生成公式
    generatedTieredFormula() {
      if (!this.tieredFeeSettings.tiers || this.tieredFeeSettings.tiers.length === 0) {
        return ''
      }
      const varName = this.tieredFeeSettings.usageVariable || 'T'
      const cumulative = this.tieredFeeSettings.cumulative
      let formula = ''
      const validTiers = this.tieredFeeSettings.tiers.filter(t => t.start !== '' && t.unitPrice !== '')
      
      if (validTiers.length === 0) {
        return ''
      }

      validTiers.forEach((tier, index) => {
        const start = parseFloat(tier.start)
        const end = tier.end === '' ? null : parseFloat(tier.end)
        const unitPrice = tier.unitPrice

        if (index > 0) {
          formula += ' + '
        }

        if (cumulative) {
          if (end === null) {
            formula += `(${varName}>${start}?${varName}-${start}:0)*${unitPrice}`
          } else {
            formula += `(${varName}>${start}?(${varName}>${end}?${end}-${start}:${varName}-${start}):0)*${unitPrice}`
          }
        } else {
          if (end === null) {
            formula += `(${varName}>${start}?${varName}:0)*${unitPrice}`
          } else {
            formula += `(${varName}>${start} && ${varName}<=${end}?${varName}*${unitPrice}:0)`
          }
        }
      })
      return formula
    },
    // 生成费用示例数据
    tieredFeeExamples() {
      if (!this.tieredFeeSettings.tiers || this.tieredFeeSettings.tiers.length === 0) {
        return []
      }
      const validTiers = this.tieredFeeSettings.tiers.filter(t => t.start !== '' && t.unitPrice !== '')
      if (validTiers.length === 0) {
        return []
      }
      const examples = []
      validTiers.forEach(tier => {
        if (tier.start !== '' && tier.unitPrice !== '') {
          if (!examples.find(e => e.value === parseFloat(tier.start))) {
            examples.push({ value: parseFloat(tier.start), tier: tier })
          }
          if (tier.end !== '' && tier.end !== null) {
            if (!examples.find(e => e.value === parseFloat(tier.end))) {
              examples.push({ value: parseFloat(tier.end), tier: tier })
            }
            const midValue = Math.floor((parseFloat(tier.start) + parseFloat(tier.end)) / 2)
            if (!examples.find(e => e.value === midValue)) {
              examples.push({ value: midValue, tier: tier })
            }
          }
        }
      })
      const lastTier = validTiers[validTiers.length - 1]
      if (lastTier.end !== '' && lastTier.end !== null) {
        const beyondValue = parseFloat(lastTier.end) + 10
        if (!examples.find(e => e.value === beyondValue)) {
          examples.push({ value: beyondValue, tier: lastTier })
        }
      } else {
        if (!examples.find(e => e.value === parseFloat(lastTier.start) + 10)) {
          examples.push({ value: parseFloat(lastTier.start) + 10, tier: lastTier })
        }
      }
      return examples.sort((a, b) => a.value - b.value)
    }
  },
  created() {
    this.loadDicts()
  },
  // 方法
  methods: {
    // 打开弹窗
    open() {
      this.visible = true
    },

    // 加载字典数据
    async loadDicts() {
      try {
        const [feeTypeCds, computingFormulas, feeFlags, paymentCds] = await Promise.all([
          getDict('pay_fee_config', 'fee_type_cd'),
          getDict('pay_fee_config', 'computing_formula'),
          getDict('pay_fee_config', 'fee_flag'),
          getDict('pay_fee_config', 'payment_cd')
        ])

        this.feeTypeCds = feeTypeCds
        this.computingFormulas = computingFormulas
        this.feeFlags = feeFlags
        this.paymentCds = paymentCds
      } catch (error) {
        console.error('Failed to load dictionaries:', error)
        this.$message.error(this.$t('common.loadFailed'))
      }
    },

    // 根据费用类型自动设置相关字段
    changeAddFeeTypeCd() {
      const feeTypeCd = this.form.feeTypeCd

      // 水费、电费、煤气费
      if (['888800010015', '888800010016', '888800010009'].includes(feeTypeCd)) {
        this.form.feeFlag = '2006012'
        this.form.computingFormula = '5005'
        this.form.paymentCd = '2100'
      }

      // 押金
      if (feeTypeCd === '888800010006') {
        this.form.feeFlag = '2006012'
      }

      // 取暖费
      if (feeTypeCd === '888800010011') {
        this.form.feeFlag = '1003006'
        this.form.computingFormula = '3003'
      }

      // 物业费
      if (feeTypeCd === '888800010001') {
        this.form.feeFlag = '1003006'
        this.form.computingFormula = '1001'
      }

      // 租金
      if (feeTypeCd === '888800010018') {
        this.form.feeFlag = '1003006'
        this.form.computingFormula = '1101'
      }

      // 停车费
      if (feeTypeCd === '888800010008') {
        this.form.feeFlag = '1003006'
        this.form.computingFormula = '2002'
        this.form.paymentCycle = '1'
      }

      // 公摊费
      if (feeTypeCd === '888800010017') {
        this.form.feeFlag = '2006012'
        this.form.computingFormula = '4004'
        this.form.paymentCd = '2100'
      }
    },

    // 保存费用配置信息
    async saveFeeConfigInfo() {
      try {

        if (this.form.computingFormula === '2002') {
          this.form.squarePrice = "0.00"
        }

        if (['7007', '8008', '9009', '1101', '1102', '4004'].includes(this.form.computingFormula)) {
          this.form.squarePrice = "0.00"
          this.form.additionalAmount = "0.00"
        }

        if (this.form.feeFlag === '2006012') {
          this.form.paymentCycle = '1'
        }

        if (this.form.paymentCd !== '1200') {
          this.form.prepaymentPeriod = '0'
        }

        // 表单验证
        await this.$refs.form.validate()

        // 调用API保存
       const {code,msg} = await saveFeeConfig(this.form)
       if(code != 0){
        this.$message.error(msg)
        return
       }

        this.$message.success(this.$t('common.operationSuccess'))
        this.visible = false
        this.$emit('success')
      } catch (error) {
        this.$message.error(error.message || this.$t('common.saveFail'))
      }
    },

    // 重置表单
    resetForm() {
      this.$refs.form.resetFields()
      this.form = {
        feeTypeCd: '',
        feeName: '',
        feeFlag: '',
        paymentCd: '1200',
        paymentCycle: '',
        prepaymentPeriod: '1',
        computingFormula: '',
        squarePrice: '',
        additionalAmount: '0.00',
        units: '元',
        deductFrom: 'Y',
        payOnline: 'Y',
        scale: '1',
        decimalPlace: '2',
        state: 'Y',
        startTime: '2025-01-01',
        endTime: '2050-01-01',
        computingFormulaText: '',
        billType: '002',
        communityId: this.getCommunityId()
      }
      this.showTieredFee = false
      this.showTieredFeeSwitch = false
      this.tieredFeeSettings = {
        usageVariable: 'T',
        cumulative: false,
        tiers: [
          { start: '0', end: '', unitPrice: '' }
        ]
      }
    },

    // 公式类型变化时处理
    handleFormulaChange(value) {
      this.showTieredFeeSwitch = value == '7007'
      if (this.showTieredFee) {
        this.form.computingFormulaText = ''
      }
    },

    // 添加梯度行
    addTierRow() {
      const tiers = this.tieredFeeSettings.tiers
      let start = '0'
      if (tiers.length > 0) {
        const lastTier = tiers[tiers.length - 1]
        if (lastTier.end !== '' && lastTier.end !== null) {
          start = lastTier.end
        }
      }
      this.tieredFeeSettings.tiers.push({ start: start, end: '', unitPrice: '' })
    },

    // 删除梯度行
    removeTierRow(index) {
      if (this.tieredFeeSettings.tiers.length > 1) {
        this.tieredFeeSettings.tiers.splice(index, 1)
        if (index === 0 && this.tieredFeeSettings.tiers.length > 0) {
          this.tieredFeeSettings.tiers[0].start = '0'
        }
      }
    },

    // 更新下一梯度的开始值（基于当前梯度的结束值）
    updateNextTierStart(index) {
      const currentTier = this.tieredFeeSettings.tiers[index]
      if (currentTier && currentTier.end !== '' && index < this.tieredFeeSettings.tiers.length - 1) {
        this.tieredFeeSettings.tiers[index + 1].start = currentTier.end
      }
    },

    // 生成公式
    generateFormula() {
      this.form.computingFormulaText = this.generatedTieredFormula
    },

    // 计算单个梯度的费用
    calculateTieredFee(tier, value) {
      const start = parseFloat(tier.start)
      const end = tier.end === '' ? null : parseFloat(tier.end)
      const unitPrice = parseFloat(tier.unitPrice)
      const cumulative = this.tieredFeeSettings.cumulative

      if (cumulative) {
        if (value <= start) return 0
        if (end !== null && value > end) {
          return (end - start) * unitPrice
        }
        return (value - start) * unitPrice
      } else {
        if (value < start) return 0
        if (end !== null && value > end) return 0
        return value * unitPrice
      }
    },

    // 计算总费用
    getTotalFee(value) {
      const validTiers = this.tieredFeeSettings.tiers.filter(t => t.start !== '' && t.unitPrice !== '')
      const cumulative = this.tieredFeeSettings.cumulative

      if (cumulative) {
        let total = 0
        validTiers.forEach(tier => {
          total += this.calculateTieredFee(tier, value)
        })
        return total.toFixed(2)
      } else {
        for (const tier of validTiers) {
          const start = parseFloat(tier.start)
          const end = tier.end === '' ? null : parseFloat(tier.end)
          const unitPrice = parseFloat(tier.unitPrice)

          if (value >= start && (end === null || value <= end)) {
            return (value * unitPrice).toFixed(2)
          }
        }
        return '0.00'
      }
    }
  }
}
</script>

<style scoped>
.full-width-select {
  width: 100%;
}
</style>